import type { CSSProperties } from 'react';

// Shared filter-pill styling across the receipt pages.
// Inactive → neutral grey; active → the supplied status/category colour, or
// brand teal when no colour is given (the "All" pill).
export interface PillColor {
  bg: string;
  fg: string;
  border?: string;
}

export function pillStyle(active: boolean, color?: PillColor): CSSProperties {
  if (!active) return { background: '#F5F7FA', color: '#595A60', border: '1px solid transparent' };
  if (color)   return { background: color.bg, color: color.fg, border: `1px solid ${color.border ?? 'transparent'}` };
  return { background: '#2D7575', color: 'white', border: '1px solid transparent' };
}
